import React from 'react';
import { FeatureGroup } from '@wix/package-picker-components';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import s from './PlansGrid.scss';
import { FeaturesGroupSection, AdvancedPlansProductData } from '../../../types';
import { FeatureRow } from './FeatureRow';

interface CollapsibleGroupProps {
  group: FeaturesGroupSection;
  products: AdvancedPlansProductData[];
  isJapanesePackagePicker?: boolean;
}

export const CollapsibleGroup: React.FC<CollapsibleGroupProps> = ({
  group,
  products,
  isJapanesePackagePicker,
}) => {
  const { t } = useTranslation();

  return (
    <FeatureGroup
      header={
        <Box>
          <Text size='small' weight='bold'>
            {t(group.translationKey)}
          </Text>
        </Box>
      }
      groupHeaderClassName={s.groupHeader}
      collapsible
      labels={{
        open: t('studio_package_picker.show_features'),
        close: t('studio_package_picker.close_features'),
      }}
    >
      {group.features.map((feature, idx) => (
        <FeatureRow
          key={idx}
          products={products}
          feature={feature}
          isJapanesePackagePicker={isJapanesePackagePicker}
        />
      ))}
    </FeatureGroup>
  );
};
